import { render, staticRenderFns } from "./Parceria_Sintraadete.vue?vue&type=template&id=fe44311e"
import script from "./Parceria_Sintraadete.vue?vue&type=script&lang=js"
export * from "./Parceria_Sintraadete.vue?vue&type=script&lang=js"
import style0 from "./Parceria_Sintraadete.vue?vue&type=style&index=0&id=fe44311e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports